/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function($) {
  $('.pah-arc-block').find('.pah-block-inner-heading').click(function(){
    var isActive = $(this).hasClass("active");
          $('.pah-block-inner-heading').removeClass('active')
    if (!isActive) {
      $(this).toggleClass('active');
    }
    $(this).next().slideToggle('fast'); 
    $(".pah-block-content").not($(this).next()).slideUp('fast');
  });

  $('.faq-block').find('.faq-block-heading').click(function(){
    var isActive = $(this).hasClass("active");
          $('.faq-block-heading').removeClass('active')
    if (!isActive) {
      $(this).toggleClass('active');
    }
    $(this).next().slideToggle('fast'); 
    $(".faq-block-content").not($(this).next()).slideUp('fast');
  });

  $(".oe-row:not(.stack-items)").slick({
    dots:true,
    arrows:false,
    infinite:false,
    centerMode: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          centerPadding: '0px',
        }
      }
    ]
  });
  $(".feature-icon-product__list").slick({
    dots: false,
    arrows: false,
    infinite:false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  
  $(".tm-wrapper").slick({
    arrows:true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $(".faq-category_row").slick({
    dots: false,
    arrows: true,
    infinite:false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite:true,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          centerPadding: '80px',
        }
      }
    ]
  });

  // ================= FAQ START ================= //
  $('.faq-category_item_question').click(function(){
   $(this).parent().toggleClass('active');
   $(this).toggleClass('active');
   $(this).next('.faq-category_item_ans').slideToggle();
  });

  $('.faq-category_col a').click(function(e){
    e.preventDefault();
    var tab_id = $(this).attr('href');

    $('.faq-category_col a').removeClass('active');
    $('.faq-category-content_inner').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  });
  
  $( ".faq-category-content_inner" ).each(function() {
    if($(this).find('.faq-category_column').length > 8){
       $(this).find('.faq-know-more-button_wrapper').show();
    }else{
        $(this).find('.faq-know-more-button_wrapper').hide();
    }
  });
  
  $('.faq-know-more').click(function(e){
    e.preventDefault();
    $(this).parents('.faq-category-content_inner').find('.faq-category_column.know-more').toggleClass('active');
    $(this).text($(this).text() == 'Know More' ? 'Know Less' : 'Know More');
  });
  // ================= FAQ END ================= //

  $(".assessment-heart_progress").on("change",function() {
    $('.assessment-step').removeClass('active');
    if(this.value <= 33.33){
        $('.assessment-step:first-child').addClass('active');
    }
    if(this.value >= 33.33 && this.value <= 66.66){
        $('.assessment-step:nth-child(2)').addClass('active');
    }
    if(this.value >= 66.66){
        $('.assessment-step:nth-child(3)').addClass('active');
    }
  });
  if (window.matchMedia('(max-width: 740px)').matches){
    $(".assessment-heart_progress").width($('.assessment-steps_row').innerHeight());
  }

  $('.read_more_less-button').click(function() {
    $(this).parents('.read_more_less-text').toggleClass('active');
    if ($(this).text() == "Read More") {
      $(this).text("Read Less")
    } else {
      $(this).text("Read More")
    }
  });

    $('a[href^="#"]').on('click',function (e) {
      var target = this.hash,
          $target = $(target);
      $('html').removeClass('lock-all');
      $('mobile-navigation').removeAttr( "open" )
      $('html, body').stop().animate({
        'scrollTop': $target.offset().top-70
      }, 900, 'swing', function () {
        window.location.hash = target;
      });
    });

  // ASK AN EXPERT
  $('.question-category_que').click(function(){
     $(this).parent().toggleClass('active');
      $(this).toggleClass('active');
      $(this).next().slideToggle();
  });

  setTimeout(function(){ 
    $(".question-category").each(function(i) {
       if($(this).attr('href') == 'all'){
        $(this).trigger('click');    
       }
    });
  }, 500);
  
  $('body').on('click', '.question-category', function(e) {
    // $('.question-category').click(function(e){
    e.preventDefault();
    var tab_id = $(this).attr('href');

    $(".question-category_qa-block").removeClass('active');
    $(".question-category_que").removeClass('active');
    $(".question-category_ans").slideUp();
    if(tab_id == 'all'){
      $('.question-category').removeClass('active');
      $(this).addClass('active');
      $('.question-categories_content-wrapper').addClass('active'); 

       // if($('.question-category_qa-block').length > 10){
       //    $('.qa-read-more-button_wrapper').show();
       //  }else{
       //    $('.qa-read-more-button_wrapper').hide();
       //  }
        
        // $(".question-category_qa-block").each(function(i) {
        //   if(i > 10){
        //     $(this).addClass('qa-read-more-block hide');
        //   }
        // });
        
        // $('.qa-read-more').click(function(e){
        //   e.preventDefault();
        //   $('.qa-read-more-block').toggleClass('hide');
        //   $(this).text($(this).text() == 'READ MORE' ? 'READ LESS' : 'READ MORE');
        // });
    }else{

      $('.qa-read-more-button_wrapper').hide();
      $('.question-category').removeClass('active');
      $('.question-categories_content-wrapper').removeClass('active');
  
      $(this).addClass('active');
      $("#"+tab_id).addClass('active'); 
    }
  });

  $('.brand-logo:first-child').addClass('active');
  $('.brand-logo-content_block').hide();
  $('.brand-logo-content_block:first').show();
  
  // Click function
  $('.brand-logo').click(function(){
    $('.brand-logo').removeClass('active');
    $(this).addClass('active');
    $('.brand-logo-content_block').hide();
    
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  $('.twitw_btn.has-popup').click(function(e){
    e.preventDefault();
    var activeTab = $(this).attr('href');
    $(`#${activeTab}`).show();
    return false;
  });
  $('.popup_image-close,.popup_image-overlay').click(function(){
    $(this).parents('.popup_image-main').hide();
    return false;
  });

  let offset = 120;	
  var currentURL = window.location.href;
  let hash = currentURL.split("/healthcare")[1];
  let $target = $(hash);
    setTimeout(function(){ 
      if($target.length){
        $("html,body").stop().animate({
            scrollTop: $target.offset().top - offset
        }, 100, function(){
          if(history.pushState) {
            history.pushState(null, null, hash);
          }
        });
      }
    }, 100);

  //COPYCODE
  const span = document.querySelector(".copycode");
  span.onclick = function() {
    document.execCommand("copy");
  }
  span.addEventListener("copy", function(event) {
    event.preventDefault();
    if (event.clipboardData) {
      event.clipboardData.setData("text/plain", span.textContent);
    }
  });

  

});